import { Action, createReducer, on } from '@ngrx/store';

import { SessionActions } from '../user/auth/auth.actions';
import { PaymentMethodModel } from '../../../../models/payment.model';
import { UserPaymentCardsActions } from './payments.actions';

export interface PaymentsState {
  userPaymentCards: PaymentMethodModel[];
  loaded: boolean;
  error: any;
}

const initialState: PaymentsState = {
  userPaymentCards: [],
  loaded: false,
  error: null,
};

export const paymentsReducer = createReducer(
  initialState,

  // System Plans
  on(UserPaymentCardsActions.load, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(UserPaymentCardsActions.loadSuccess, (state, { cards }) => {
    return {
      ...state,
      userPaymentCards: cards,
      loaded: true,
    };
  }),

  on(UserPaymentCardsActions.loadFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: false,
  })),

  on(SessionActions.forget, (state) => initialState)
);
